import type { ConfigType } from '@plone/registry';
import installBlocks from './config/blocks';
import installContent from './config/content';
import installRoutes from './config/routes';
import installSettings from './config/settings';
import installSlots from './config/slots';
import installWidgets from './config/widgets';

function applyConfig(config: ConfigType) {
  installBlocks(config);
  installSettings(config);
  installBlocks(config);
  installWidgets(config);
  installContent(config);
  installRoutes(config);
  installSlots(config);
  return config;
}

export default applyConfig;
